module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AX-e072516bbb0b58a3f48504a79e26945c.png";